import { Upload } from "antd";
import { message } from "@bindeleddet/core/utils";

const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"];
const ALLOWED_IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".gif", ".webp"];

export const IMAGE_ACCEPT = "image/jpeg,image/jpg,image/png,image/gif,image/webp";

export const isImageFile = (file: File): boolean => {
  return (
    ALLOWED_IMAGE_TYPES.includes(file.type) ||
    ALLOWED_IMAGE_EXTENSIONS.some(ext => file.name.toLowerCase().endsWith(ext))
  );
};

export const validateImageFile = (
  file: File,
  errorMessage = "Filen må være et bilde (JPG, PNG, GIF eller WebP)"
): boolean => {
  if (!isImageFile(file)) {
    message("error", "Ugyldig filtype", errorMessage);
    return false;
  }
  return true;
};

export const beforeUploadImage = (file: File, errorMessage?: string): false | typeof Upload.LIST_IGNORE => {
  if (!validateImageFile(file, errorMessage)) {
    return Upload.LIST_IGNORE;
  }
  return false; // Prevent auto upload
};
